export class TelephonePoco {
    telephone!: string
    ext!: string
}
